/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SimpleAttachResponse
 */
export interface SimpleAttachResponse {
    /**
     * 
     * @type {string}
     * @memberof SimpleAttachResponse
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof SimpleAttachResponse
     */
    claimReference: string;
    /**
     * 
     * @type {any}
     * @memberof SimpleAttachResponse
     */
    originalBytes: any | null;
    /**
     * 
     * @type {any}
     * @memberof SimpleAttachResponse
     */
    importedBytes: any | null;
}

/**
 * Check if a given object implements the SimpleAttachResponse interface.
 */
export function instanceOfSimpleAttachResponse(value: object): value is SimpleAttachResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('claimReference' in value) || value['claimReference'] === undefined) return false;
    if (!('originalBytes' in value) || value['originalBytes'] === undefined) return false;
    if (!('importedBytes' in value) || value['importedBytes'] === undefined) return false;
    return true;
}

export function SimpleAttachResponseFromJSON(json: any): SimpleAttachResponse {
    return SimpleAttachResponseFromJSONTyped(json, false);
}

export function SimpleAttachResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleAttachResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'claimReference': json['claimReference'],
        'originalBytes': json['originalBytes'],
        'importedBytes': json['importedBytes'],
    };
}

export function SimpleAttachResponseToJSON(value?: SimpleAttachResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
        'claimReference': value['claimReference'],
        'originalBytes': value['originalBytes'],
        'importedBytes': value['importedBytes'],
    };
}

